import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import classnames from "classnames";
import { withStyles } from "@material-ui/styles";
import Cookies from "universal-cookie";

import Header from "../Header/Header";
import Sidebar from "../Sidebar";

// pages
import EditCorsoBilling from "../../pages/billing/editCorso/EditCorso";
import EditStudenteBilling from "../../pages/billing/editStudente/EditStudente";
import StudenteDetailsBilling from "../../pages/billing/studenteDetails/StudenteDetails";
import Corsi from "../../pages/corsi";
import CorsiEliminati from "../../pages/corsiEliminati";
import AddCorso from "../../pages/addCorso";
import EditCorso from "../../pages/editCorso";
import Studenti from "../../pages/studenti";
import Insegnanti from "../../pages/insegnanti";
import AddStudente from "../../pages/addStudente";
import EditStudente from "../../pages/editStudente";
import Aule from "../../pages/aule";
import Invoices from "../../pages/invoices";
import AddAula from "../../pages/addAula";
import Schedule from "../../pages/schedule";
import Scuola from "../../pages/scuola";
import GestionePresenze from "../../pages/gestionePresenze";
import AdminSettings from "../../pages/adminsettings";
import PdfCorsoPage from "../../pages/pdfCorsoPage/PdfCorsoPage";
import PdfEsameSingoloPage from "../../pages/pdfEsameSingoloPage/PdfEsameSingoloPage";
import PdfFatturatoPage from "../../pages/PdfFatturatoPage";
import PdfFullCourse from "../../pages/pdfFullCourse/PdfFullCourse";
import PdfExam from "../../pages/pdfExam/PdfExam";
import PdfSingleStudent from "../../pages/pdfSingleStudent/PdfSingleStudent";
import DetailAula from "../../pages/detailAula/DetailAula";
import PdfAulaPage from "../../pages/pdfAulaPage/PdfAulaPage";
import PdfRiepilogoPresenze from "../../pages/pdfRiepilogoPresenze/PdfRiepilogoPresenze";

// context
import EsameDetails from "../../pages/esameDetails/EsameDetails";
import GestioneAssenze from "../../pages/gestioneAssenze/GestioneAssenze";
import Search from "../../pages/search/Search";
import Eventi from "../../pages/eventi/Eventi";
import AddEvento from "../../pages/addEvento/AddEvento";
import EditEvento from "../../pages/editEvento/EditEvento";
import NotificheAssenze from "../../pages/notificheAssenze/NotificheAssenze";
import AddInsegnante from "../../pages/addInsegnante/AddInsegnante";
import AddMateria from "../../pages/addMateria/AddMateria";
import Materie from "../../pages/materie/Materie";
import EditMateria from "../../pages/editMaterie/EditMaterie";
import EditInsegnante from "../../pages/editInsegnante/EditInsegnante";
import Categorie from "../../pages/categorie/Categorie";
import AddCategorie from "../../pages/addCategorie/AddCategorie";
import Tag from "../../pages/tag/Tag";
import AddTag from "../../pages/addTag/AddTag";
import EditTag from "../../pages/editTag/EditTag";
import Leads from "../../pages/leads/Leads";
import EditLead from "../../pages/editLead/EditLead";
import AddLead from "../../pages/addLead/AddLead";
import DaChiamare from "../../pages/daChiamare/DaChiamare";
import Chiamati from "../../pages/chiamati/Chiamati";
import BlackList from "../../pages/blacklist/Blacklist";
import Dashboard from "../../pages/dashboard/Dashboard";
import Sconti from "../../pages/sconti/Sconti";
import AddSconto from "../../pages/addSconto/AddSconto";
import PdfCalendarioCorsoPage from "../../pages/pdfCalendarioCorsoPage/PdfCalendarioCorsoPage";
import Notifiche from "../../pages/notifiche/Notifiche";
import Recuperi from "../../pages/recuperi/Recuperi";

const makeStyles = (theme) => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: `calc(100vw - 240px)`,
    minHeight: "100vh",
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px) `,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    ...theme.mixins.toolbar,
  },
});

class Layout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuItems: [],
      searchParams: "",
    };
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const appId = cookies.get("appId", { path: "/" });
  }

  searchGlobal(text) {
    this.setState({ searchParams: text });
    window.sessionStorage.setItem("search_text", text);
  }

  render() {
    // global
    const { classes } = this.props;

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const userType = cookies.get("userType", { path: "/" });

    if (userType == 4) {
      return (
        <div className={classes.root}>
          <>
            <Header
              history={this.props.history}
              onSearch={(s) => this.searchGlobal(s)}
            />
            <Sidebar menuItems={this.state.menuItems} />
            <div
              className={classnames(classes.content, {
                [classes.contentShift]: null,
              })}
            >
              <div className={classes.fakeToolbar} />

              <Switch>
                <Route path="/app/dachiamare" component={DaChiamare} />
                <Route path="/app/dashboard" component={Dashboard} />
                <Route path="/app/chiamati" component={Chiamati} />
                <Route path="/app/editLead" component={EditLead} />
                <Route path="/app/addLead" component={AddLead} />
                <Route path="/app/tag" component={Tag} />
                <Route path="/app/addTag" component={AddTag} />

                <Route path="/app/usersettings" component={AdminSettings} />
                <Route
                  exact
                  path="/app/ui"
                  render={() => <Redirect to="/app/ui/icons" />}
                />
              </Switch>
            </div>
            <div className={classnames(classes.contentPhone)}></div>
          </>
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <>
          <Header
            history={this.props.history}
            onSearch={(s) => this.searchGlobal(s)}
          />
          <Sidebar menuItems={this.state.menuItems} />
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: null,
            })}
          >
            <div className={classes.fakeToolbar} />

            <Switch>
              <Route
                path="/app/billing/editCorso"
                component={EditCorsoBilling}
              />
              <Route
                path="/app/billing/editStudente"
                component={EditStudenteBilling}
              />
              <Route
                path="/app/billing/studenteDetails"
                component={StudenteDetailsBilling}
              />
              <Route path="/app/corsi" component={Corsi} />
              <Route path="/app/categorie" component={Categorie} />
              <Route path="/app/cestinoCorsi" component={CorsiEliminati} />
              <Route path="/app/notifiche" component={Notifiche} />
              <Route path="/app/addCorso" component={AddCorso} />
              <Route path="/app/addCategorie" component={AddCategorie} />
              <Route path="/app/editCorso" component={EditCorso} />
              <Route path="/app/dashboard" component={Dashboard} />
              <Route path="/app/studenti" component={Studenti} />
              <Route path="/app/insegnanti" component={Insegnanti} />
              <Route path="/app/addInsegnante" component={AddInsegnante} />
              <Route path="/app/editInsegnante" component={EditInsegnante} />
              <Route path="/app/materie" component={Materie} />
              <Route path="/app/addMateria" component={AddMateria} />
              <Route path="/app/addStudente" component={AddStudente} />
              <Route path="/app/editStudente" component={EditStudente} />
              <Route path="/app/esameDetails" component={EsameDetails} />
              <Route path="/app/invoices" component={Invoices} />
              {/* <Route path="/app/sconti" component={Sconti} /> */}
              {/* <Route path="/app/addSconto" component={AddSconto} /> */}
              <Route path="/app/aule" component={Aule} />
              <Route path="/app/blacklist" component={BlackList} />
              <Route path="/app/detailAula" component={DetailAula} />
              <Route path="/app/addAula" component={AddAula} />
              <Route path="/app/schedule" component={Schedule} />
              <Route path="/app/scuola" component={Scuola} />
              <Route path="/app/leads" component={Leads} />
              <Route path="/app/tag" component={Tag} />
              <Route path="/app/pdfCorsoPage" component={PdfCorsoPage} />
              <Route
                path="/app/pdfFatturatoPage"
                component={PdfFatturatoPage}
              />
              <Route
                path="/app/pdfEsameSingoloPage"
                component={PdfEsameSingoloPage}
              />
              <Route path="/app/pdfFullCourse" component={PdfFullCourse} />
              <Route
                path="/app/pdfCalendarioCorso"
                component={PdfCalendarioCorsoPage}
              />{" "}
              <Route path="/app/pdfExam" component={PdfExam} />
              <Route
                path="/app/pdfSingleStudent"
                component={PdfSingleStudent}
              />
              <Route
                path="/app/pdfRiepilogoPresenze"
                component={PdfRiepilogoPresenze}
              />
              <Route path="/app/pdfAulaPage" component={PdfAulaPage} />
              <Route
                path="/app/gestionePresenze"
                component={GestionePresenze}
              />
              <Route path="/app/gestioneAssenze" component={GestioneAssenze} />
              <Route path="/app/eventi" component={Eventi} />
              <Route path="/app/recuperi" component={Recuperi} />
              <Route path="/app/addEvento" component={AddEvento} />
              <Route path="/app/addLead" component={AddLead} />
              <Route path="/app/addTag" component={AddTag} />
              <Route path="/app/editEvento" component={EditEvento} />
              <Route path="/app/editMateria" component={EditMateria} />
              <Route path="/app/editTag" component={EditTag} />
              <Route path="/app/editLead" component={EditLead} />
              <Route
                path="/app/search"
                component={Search}
                searchText={this.state.searchParams}
              />
              <Route path="/app/gestioneAnnunci" component={NotificheAssenze} />
              <Route path="/app/usersettings" component={AdminSettings} />
              <Route
                exact
                path="/app/ui"
                render={() => <Redirect to="/app/ui/icons" />}
              />
            </Switch>
          </div>
          <div className={classnames(classes.contentPhone)}></div>
        </>
      </div>
    );
  }
}

export default withStyles(makeStyles)(withRouter(Layout));
